export const colors = {
  black: "#23262F",
  blue: "#3371F5",
  blueHover: "#2965E6",
  blueLight: "#F5F9FF",
  darkGray: "#3D3D3D",
  gray: "#F8F8F8",
  gray2: "#F4F4F4",
  gray3: "#F6F6F6",
  gray4: "#E6E8EC",
  gray5: "#777E90",
  gray6: "#E6E8EC",
  gray7: "#777E91",
  gray8: "#777",
  gray9: "#F4F5F6",
  green: "#0AC05E",
  greenLight: "#E1FFEF",
  red: "#FF5119",
  orange: "#FFAA00",
  whiteish: "#FCFCFD",
};

export const fonts = {
  dmSans: "'DM Sans', sans-serif",
  gilroy: "'Gilroy', sans-serif",
  poppins: "'Poppins', sans-serif",
};

export const fontSizes = {
  xl: "2.4rem",
  lg2: "2.2rem",
  lg: "2.2rem",
  md: "1.6rem",
  sm: "1.4rem",
  xs: "1.2rem",
};

export const sizes = {
  avatar: "46px",
  avatarMobile: "32px",
  headerSearchbox: "50px",
  headerHeight: "90px",
  headerMobileHeight: "104px",
  sectionMaxWidth: "1150px",
  headerMaxWith: "1185px",
  mainMaxWidth: "1250px",
};

export const screens = {
  sm: "(min-width:480px)",
  md: "(min-width:768px)",
  lg: "(min-width:1024px)",
  lg2: "(min-width:1280px)",
  lg3: "(min-width:1440px)",
  xl: "(min-width:1600px)",
};

export const shadows = {
  black: "0px 40px 32px -24px rgba(15, 15, 15, 0.12)",
  blue: "0px 10px 30px rgba(0, 108, 255, 0.4)",
};

export const radius = {
  roundedXS: "5px",
  roundedSM: "10px",
  roundedMD: "15px",
  roundedLG: "20px",
  roundedXL: "30px",
};

export const padding = {
  mobileCommon2: "16px",
  mobileCommon: "20px",
};

export const indexes = {
  backdrop: 1000,
  poppedUI: 50,
  mobileMenu: 1100,
  snackbar: 130,
};

export const transitions = {
  buttonBgHover: "background-color 150ms",
};
